import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ICON_REFRESH, ICON_SEARCH } from '../../extras/icons';
//Redux
import { listJudgesAction } from '../../../actions/judgesActions';
import { listLicenceTypesAction } from '../../../actions/licenceTypesActions';
//Axios
import clienteAxios from '../../../config/axios';

import { ErrorMessage } from '../../extras/toastMessages';
import { MSG_ERROR_SELECT_FILTER, MSG_ERROR_SERVER } from '../../../constants/messages';
//Función principal
const LicenceSearch = props => {
    //Tomo los props
    const { setSearch } = props;
    //Inicializo
    const initialFilter = {
        operator: '',
        type: '',
        fecha: ''
    }
    //Inicializo el dispatch
    const dispatch = useDispatch();
    //Traigo del store
    const licenceTypesLoading = useSelector( state => state.licenceTypes.loading );
    const licenceTypes = useSelector( state => state.licenceTypes.licenceTypes );
    //Inicializo el state local
    const [ filter, setFilter ] = useState(initialFilter);
    const [ operators, setOperators ] = useState(null);
    const [ operatorsLoading, setOperatorsLoading ] = useState(false);
    //Manejo el cambio de valores
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    }
    //Cargo los parámetros
    const loadParameters = () => {
        //Seteo los params
        loadOperators();
        //Seteo los params
        const paramsTypes = {
            search: 'activo:1',
            sort: 'descripcion:asc'
        }
        //Llamo al dispatch
        dispatch( listLicenceTypesAction(paramsTypes) );
    }
    //Cargo los operadores
    const loadOperators = async () => {
        try{
            //Cargo espesra
            setOperatorsLoading(true);
            //Operadores
            const responseOperators = await clienteAxios.get(`/usuario?search=activo:1,perfil.id:2,nivel.id:3&sort=apellido:asc,nombre:asc`);
            //Seteo los datos
            setOperators(responseOperators.data.content);
            //Oculto espesra
            setOperatorsLoading(false);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Oculto la espera
            setOperatorsLoading(false);
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
    //Al inicio cargo
    useEffect(() => {
        //Cargo los parámetros
        loadParameters();
    }, []);
    //Manejo el submit
    const handleSubmit = e => {
        e.preventDefault();
        
        //Inicializo 
        let newSearch = '';
        //Juez
        if(filter.operator !== ''){
            newSearch += `operador.id:${filter.operator}`;
        }
        //Tipo
        if(filter.type !== ''){
            newSearch += `${newSearch !== '' ? `${newSearch},` : ''}tipo.id:${filter.type}`;
        }
        //Verifico el filtro de fecha
        if(filter.fecha !== ''){
            //Inicializo
            newSearch += `${newSearch !== '' ? ',' : ''}fecha:${filter.fecha}`;
        }
        //Me fijo si hay filtros
        if(newSearch !== ''){
            //Seteo la búsqueda
            setSearch(newSearch);
        }else{
            //Error
            ErrorMessage(MSG_ERROR_SELECT_FILTER);
        }
    }
    //Manejo el limpiar
    const handleClear = e => {
        e.preventDefault();
        setFilter(initialFilter);
        setSearch('');
    }
    //Renderizo
    return (
        <div className="row">
            <form onSubmit={handleSubmit} className="col">
                <div className="row mb-2">
                    <div className="col-md-2">
                        <label htmlFor="fecha" >Fecha</label>
                        <input type="date" className="form-control" id="fecha" name="fecha" onChange={handleChange} value={filter.fecha} disabled={operatorsLoading} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <select 
                            name="operator" 
                            className="form-control" 
                            onChange={handleChange} 
                            value={filter.operator} 
                            disabled={operatorsLoading || licenceTypesLoading}
                        >
                            <option value="">Todos los Operadores</option>
                            {
                                operators ? (
                                    operators.map(operator => (
                                        <option value={operator.id} key={`tsj${operator.id}`}>
                                            {`${operator.apellido}, ${operator.nombre}`}
                                        </option>
                                    ))
                                ) : null
                            }
                        </select>
                    </div>
                    <div className="col-md-3">
                        <select 
                            name="type" 
                            className="form-control" 
                            onChange={handleChange} 
                            value={filter.type} 
                            disabled={operatorsLoading || licenceTypesLoading}
                        >
                            <option value="">Todos los Tipos</option>
                            {
                                licenceTypes ? (
                                    licenceTypes.map(licenceType => (
                                        <option value={licenceType.id} key={`tst${licenceType.id}`}>
                                            { licenceType.descripcion }
                                        </option>
                                    ))
                                ) : null
                            }
                        </select>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="primary"
                            type="submit"
                            block
                            disabled={operatorsLoading || licenceTypesLoading}
                        >
                            <ICON_SEARCH />
                        </Button>
                    </div>
                    <div className="col-md-1">
                        <Button
                            variant="warning"
                            type="button"
                            onClick={handleClear}
                            block
                            disabled={operatorsLoading || licenceTypesLoading}
                        >
                            <ICON_REFRESH />
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default LicenceSearch;